import { Injectable, inject } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { NavigationPanelComponent, NavigationPanelConfig } from './navigation-panel.component';

@Injectable({
  providedIn: 'root'
})
export class NavigationPanelService {
  private readonly overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;
  private panelComponent: NavigationPanelComponent | null = null;

  open(config?: NavigationPanelConfig): NavigationPanelComponent {

    if (this.overlayRef) {
      this.close();
    }

    const overlayConfig: OverlayConfig = {
      hasBackdrop: true,
      backdropClass: 'navigation-panel-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .left('0')
        .top('0')
        .bottom('0'),
      panelClass: 'navigation-panel-overlay',
      scrollStrategy: this.overlay.scrollStrategies.block()
    };

    this.overlayRef = this.overlay.create(overlayConfig);

    const portal = new ComponentPortal(NavigationPanelComponent);
    const componentRef = this.overlayRef.attach(portal);
    this.panelComponent = componentRef.instance;

    if (config) {
      if (config.menuItems !== undefined) {
        this.panelComponent.menuLoad(config.menuItems);
      }
    }

    this.overlayRef.backdropClick().subscribe(() => {
      this.close();
    });

    document.body.style.overflow = 'hidden';

    this.panelComponent.closeEvent.subscribe(() => {
      this.close();
    });

    return this.panelComponent;
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef.dispose();
      this.overlayRef = null;
      this.panelComponent = null;

      document.body.style.overflow = '';
    }
  }

  isOpen(): boolean {
    return this.overlayRef !== null && this.overlayRef.hasAttached();
  }
}
